// Первоначальная конвертация цен
import { translatePrice } from '../conversion';
import { setElementState } from '../priceControls';

const matchState = (state) => {
  return (
    state.convertedCurrency === null &&
    state.originalPrice === null &&
    state.convertedPrice === null
  );
};

const handle = (priceElement, state, config) => {
  const { htmlPrice, selectedTargetCurrency } = state;

  const isOriginalCurrencySelected =
    state.baseCurrency === state.selectedTargetCurrency;
  const price = isOriginalCurrencySelected
    ? htmlPrice
    : translatePrice(htmlPrice, config);

  const newState = {
    ...state,
    convertedCurrency: selectedTargetCurrency,
    originalPrice: htmlPrice,
    convertedPrice: price,
  };

  setElementState(priceElement, newState);
};

export default { matchState, handle, name: 'init' };
